import { useDispatch, useSelector } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { DOCUMENTS_ALL, DOCUMENTS_MENU } from 'constants/controllers'
import { RootState } from 'redux/store'
import { setDocumentShowAutomatedOnly, setDocumentShowFavouritesOnly } from 'redux/actions'
import { DOCUMENTS_FAVOURITING } from 'constants/feature-flags'
import CompactSwitch from 'components/CompactSwitch'
import Breadcrumbs from 'components/Breadcrumbs'

export default function Nav ({ title, hasAutomatedDocuments }: { title: string, hasAutomatedDocuments?: boolean }): JSX.Element {
  const dispatch = useDispatch()
  const showAutomatedOnly = useSelector((state: RootState) => state.documents.showAutomatedOnly)
  const showFavouritesOnly = useSelector((state: RootState) => state.documents.showFavouritesOnly)

  return (
    <div className='layout-width-constraint mt6'>
      <Breadcrumbs
        icon='documents'
        current={title}
        crumbs={[{
          label: 'Documents',
          href: url(DOCUMENTS_MENU)
        }, {
          label: 'Corporate',
          href: `${url(DOCUMENTS_MENU, { aol: 'corporate' })}`
        }]}
        viewAllLink={url(DOCUMENTS_ALL)}
      >
        <div className='flex items-center mlauto gap3'>
          {hasAutomatedDocuments === true && (
            <CompactSwitch
              label={
                <span className='dib w11-half'>
                  Automated only
                </span>
              }
              labelPlacement='end'
              checked={showAutomatedOnly}
              onChange={() => {
                dispatch(setDocumentShowAutomatedOnly(!showAutomatedOnly))
              }}
              data-event-category='Automated Documents'
              data-event-action={showAutomatedOnly ? 'Untoggle' : 'Toggle'}
            />
          )}
          {DOCUMENTS_FAVOURITING && (
            <CompactSwitch
              label={
                <span className='dib w11-half'>
                  Favourites only
                </span>
              }
              labelPlacement='end'
              checked={showFavouritesOnly}
              onChange={() => {
                dispatch(setDocumentShowFavouritesOnly(!showFavouritesOnly))
              }}
              data-event-category='Favourites'
              data-event-action={showFavouritesOnly ? 'Toggle-Off' : 'Toggle-On'}
              data-event-label='Documents Listing'
            />
          )}
        </div>
      </Breadcrumbs>
    </div>
  )
}
